let graphicLayer; //展示线标记和面标记功能临时用。

/* 异步加载 一些弹窗组件 */
const BimVideoTree = () => import("./bimVideoTree/BimVideoTree");
const BimVideoCategory = () =>
  import("./bimVideoCategory/BimVideoCategory.vue");
const BimVideoCamera = () => import("./bimVideoCamera/BimVideoCamera.vue");

//按需加载
import {
  bimVideo,
  deleteSurveil,
  deleteBimVideoCategory,
  deleteFile,
} from "../../../api/api";

import { EventBus } from "../../../static/js/event-bus.js";

import { videoPlayer } from "vue-video-player";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";

//

export default {
  components: {
    BimVideoTree,
    BimVideoCategory,
    BimVideoCamera,
    videoPlayer,
  },
  props: {},
  data() {
    return {
      videoSurveil_show: true,
      loading: false,
      getData: [], //保存请求后台数据获取到的一维json数组【原始数组】
      treeData: [],
      treeExpandAll: true,
      treeNodeKey: "id",

      open_surveil_box: "", //当前打开的标记子弹窗，最多只同时显示一个子弹窗。
      isFold: false,

      videoDialogVisible: false,
      playerOptions: {
        // playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: true, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "rtmp/mp4",
            src: "", // url地址
          },
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false, // 当前时间和持续时间的分隔符
          durationDisplay: false, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
      option: {
        predefineColors: [
          {
            value: "white",
            label: "#ffffff",
          },
          {
            value: "rose_red",
            label: "#c71585",
          },
          {
            value: "red",
            label: "#ff4500",
          },
          {
            value: "yellow",
            label: "#ffd700",
          },
          {
            value: "light_green",
            label: "#55e8a2",
          },
          {
            value: "green",
            label: "#1ba784",
          },
          {
            value: "blue-green",
            label: "#00ced1",
          },
          {
            value: "blue",
            label: "#1e90ff",
          },
          {
            value: "purple",
            label: "#9932cd",
          },
          {
            value: "black",
            label: "#000000",
          },
        ],
      },
    };
  },
  mounted() {
    // alert(22)
    this.initTreeData();

    graphicLayer = new mars3d.layer.GraphicLayer();
    this.$GLOBAL.map.addLayer(graphicLayer);

    EventBus.$on("updateCartesian", (param) => {
      //当标记点移动时，根据标记的id获取到标记的表单信息并显现在表单上，方便准确定位和编辑、更新等。

      // this.$refs.bimVideoCamera.form.position = param.cartesianXYZ; //这行代码不应该写在这里，因为如果只加载了VideoSurveil弹窗，还没有加载SimVideoCamera弹窗，那么这段代码应该会报出this.$refs.bimVideoCamera未定义之类的错误。

      //根据编辑对象的id找到对应标记列表里的数据项，对应进行编辑。
      let tempData = "";
      if (param.mType === "pointToIcon") {
        tempData = param.cartesianXYZ;
      }
      if (tempData) {
        this.editSimVideoCameraByUid(param.mType, param.graphic.uuid, tempData);
      }
    });
  },

  methods: {
    // 初始化列表
    initTreeData() {
      this.$NProgress.configure({
        easing: "ease",
        showSpinner: true,
      });
      this.$NProgress.set(0.8).inc(0.2);
      this.loading = true;
      //axios请求 获取数据 注意将parentId:'0'转为parentId:'',以方便el-tree正常识别和显示数据。此外注意将字段名首位字母改为小写。
      let tempdata = [];
      let that = this;
      // console.log(window.sessionStorage);
      let modelData = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
      };
      // 监控列表 zhang
      bimVideo(modelData)
        .then((res) => {
          if (res.data.data && res.data.data.length > 0) {
            tempdata = res.data.data;
            let mapData = [];
            tempdata.forEach((item) => {
              item.surveilType = "directory";
              item.children.forEach((i) => {
                let {
                  labelColor,
                  description,
                  x,
                  y,
                  z,
                  url,
                  isShare,
                } = i.bimVideoCamera;
                i.surveilType = "pointToIcon";
                // console.log(
                this.option.predefineColors.find((e) => {
                  return e.value == "white";
                }).label;
                mapData.push({
                  text: i.text,
                  id: i.id,
                  pId: i.pId,
                  parentId: i.parentId,
                  points: "",
                  projectId: i.projectId,
                  surveilType: i.surveilType,
                  updatedTime: i.updatedTime,
                  updatedUserId: i.updatedUserId,
                  updatedUserName: i.updatedUserName,
                  bimVideoCamera: {
                    labelColor: this.option.predefineColors.find((e) => {
                      return (
                        e.value == (labelColor != null ? labelColor : "white")
                      );
                    }).label,
                    surveilIconColor: this.option.predefineColors.find((e) => {
                      return (
                        e.value == (labelColor != null ? labelColor : "white")
                      );
                    }).label,
                    surveilTextColor: this.option.predefineColors.find((e) => {
                      return (
                        e.value == (labelColor != null ? labelColor : "white")
                      );
                    }).label,
                    description: description || "",
                    position: `${x},${y},${z}`,
                    url: url,
                    x: x,
                    y: y,
                    z: z,
                    surveilShared: isShare != null ? isShare : true,
                  },
                });
              });
            });
            this.treeData = tempdata;
            this.getData = that.initSurveilArray(mapData);
          } else {
            that.$alert("网络不佳，请求错误！！", "请刷新页面", {
              confirmButtonText: "确定",
              type: "error",
              callback: (action) => {},
            });
            that.getData = [];
            that.refreshTree();
          }
          this.$NProgress.done(true);
          this.loading = false;
        })
        .catch((res) => {
          that.$alert("网络不佳，请求错误！！", "请刷新页面", {
            confirmButtonText: "确定",
            type: "error",
            callback: (action) => {},
          });
        });
    },

    refreshTree() {
      this.treeData = this.getTree(this.getData, "");
    },
    getTree(data, root, idTxt, pidTxt, pushTxt) {
      var idTxt = idTxt || "id";
      var pidTxt = pidTxt || "parentId";
      var pushTxt = pushTxt || "children";
      // 递归方法
      function getNode(id) {
        var node = [];
        for (var i = 0; i < data.length; i++) {
          if (data[i][pidTxt] == id) {
            let tdata = getNode(data[i][idTxt]);
            if (!tdata) {
              tdata = [];
            }
            data[i][pushTxt] = tdata;
            node.push(data[i]);
          }
        }
        if (node.length == 0) {
          return;
        } else {
          return node;
        }
      }
      // 使用根节点
      return getNode(root);
    },

    videoSurveil_click() {
      //alert("触发");
      if (this.$GLOBAL.markDrawGraphicLayer) {
        this.$GLOBAL.markDrawGraphicLayer.clear();
      }

      if (this.$GLOBAL.markDrawGraphicLayer2) {
        this.$GLOBAL.markDrawGraphicLayer2.clear();
      }
      this.$emit("videoSurveilBox_close");
    },

    //弹出表单新增标记目录
    createBimVideoCategory(data) {
      let fdata = data.filter(function(fp) {
        return fp.surveilType === "directory";
      });

      this.open_surveil_box = "BimVideoCategory";

      this.$refs.bimVideoCategory.addDirectory();
    },
    //目录树添加新增的标记目录
    addBimVideoCategory(data) {
      this.$refs.BimVideoTree.treeAddItem(data);

      this.getData.push(data);
    },
    // 弹出表单修改标记目录
    editTreeItem(data) {
      // 打开编辑弹窗
      let fdata = this.getData.filter(function(fp) {
        return fp.surveilType === "directory" && fp.id !== data.id;
      });

      this.open_surveil_box = "BimVideoCategory";

      this.$refs.bimVideoCategory.editDirectory(data, fdata);
    },
    // 目录树更新已修改成功的标记目录
    updateTreeItem(data) {
      this.$refs.BimVideoTree.treeEditItem(data);
    },
    // 删除目录
    deleteTreeItem(data) {
      let that = this;
      this.$confirm("确定删除该分类吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除树节点
          if (data.children == undefined || data.children.length <= 0) {
            //axios请求删除节点代码
            let mddData = {
              projectId: parseInt(
                window.sessionStorage.getItem("nowProjectId")
              ),
              id: data.id,
            };
            // 添加摄像头分类 zhang delete
            deleteBimVideoCategory(mddData).then((res) => {
              // console.log(JSON.parse(JSON.stringify(res)));
              // console.log(444444444444);
              if (res.data.success && res.data.code === 204) {
                that.initTreeData(); //请求后台数据刷新
                //this.$refs.BimVideoTree.treeDeleteItem(data); //本地刷新，演示效果用,但会导致一个问题，就是旧数据里的数据没有更新。
                //同时还要关闭第二个弹窗，避免已删除的信息的编辑弹窗还在。
                that.open_surveil_box = "";

                that.$notify({
                  title: "已成功删除该分类。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                that.$alert("删除该分类失败了，请再试一次吧~", "删除失败", {
                  confirmButtonText: "确定",
                  type: "error",
                  callback: (action) => {},
                });
              }
            });
          } else {
            this.$alert("删除失败，因为该分类下内容不为空。", "友情提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
        });
    },
    //弹出新增标记弹窗
    createSimVideoCamera(data, mType = "pointToIcon") {
      let fdata = data;
      // console.log(data);

      // 注意当SimVideoCamera的父组件VideoSurveil组件的弹窗出现时，SimVideoCamera组件就已经加载了，mounted方法也会执行一遍。
      if (this.$GLOBAL.markDrawGraphicLayer2) {
        //alert(2);
        this.$GLOBAL.markDrawGraphicLayer2.clear();
        this.$GLOBAL.map.removeLayer(this.$GLOBAL.markDrawGraphicLayer2, true);
      }
      this.$GLOBAL.markDrawGraphicLayer2 = new mars3d.layer.GraphicLayer({
        hasEdit: true,
        isAutoEditing: true, //绘制完成后是否自动激活编辑
      });
      this.$GLOBAL.map.addLayer(this.$GLOBAL.markDrawGraphicLayer2);

      this.$refs.bimVideoCamera.bimVideoCamera_click();
      this.open_surveil_box = "BimVideoCamera";
      this.$refs.bimVideoCamera.addSurveil(fdata, mType);
    },
    //目录树添加新增的标记
    addSimVideoCamera(data) {
      this.$refs.BimVideoTree.treeAddItem(data);
      this.getData.push(data);
    },
    // 弹出表单修改标记弹窗。
    async editSimVideoCamera(data) {
      // console.log(666666666666666);
      // console.log(JSON.parse(JSON.stringify(data)));
      let fdata = this.getData.filter(function(fp) {
        return fp.surveilType === "directory" && fp.id !== data.id;
      });
      let tempFileList = [];
      //在这里根据localFiles获取文件列表并展示。
      data.fileList = tempFileList;
      // console.log(JSON.parse(JSON.stringify(tempFileList)));
      // console.log('99999999999')
      // return false;

      this.$refs.bimVideoCamera.editSurveil(data, this.treeData);
      this.open_surveil_box = "BimVideoCamera";

      // console.log(8888888888888);
      // console.log(JSON.parse(JSON.stringify(data)));
      this.surveilNodeClick(data);
    },
    //根据标记对象uid找到编辑对象的数据
    findSimVideoCameraByUid(uid) {
      return this.getData.filter(function(fp) {
        return fp.uid === uid;
      });
    },
    //根据标记对象id弹出编辑对象的弹窗，适用于用户直接在地图上移动标记时触发该标记的编辑弹窗。
    editSimVideoCameraByUid(mType, uid, tempData = null) {
      let surveildata = this.findSimVideoCameraByUid(uid);
      //alert(point)
      if (surveildata && surveildata.length > 0) {
        //避免地图上标记点移动位置后，移动前弹出表单里填写的信息被重置，且与地图标识显示不同。
        let nowFormData = this.$refs.bimVideoCamera.data;
        let showData = surveildata[0];
        //要考虑到一种情况，就是bimVideoCamera弹窗还在时，切换了移动的标记。
        if (
          nowFormData.id === showData.id &&
          JSON.stringify(nowFormData) != "{}"
        ) {
          //let itemArr=['parentId','name','description','position','fileList','fileData','surveilIconColor','surveilTextColor','surveilShared'];
          if (nowFormData.parentId) {
            showData.parentId = nowFormData.parentId;
          }
          if (nowFormData.name) {
            showData.name = nowFormData.name;
          }
          if (nowFormData.description) {
            showData.description = nowFormData.description;
          }
          // alert(nowFormData.position)
          if (nowFormData.position) {
            showData.position = nowFormData.position;
          }

          if (nowFormData.fileList) {
            showData.fileList = nowFormData.fileList;
          }
          if (nowFormData.fileData) {
            showData.fileData = nowFormData.fileData;
          }

          if (nowFormData.surveilIconColor) {
            showData.surveilIconColor = nowFormData.surveilIconColor;
          }
          if (nowFormData.surveilTextColor) {
            showData.surveilTextColor = nowFormData.surveilTextColor;
          }
          if (nowFormData.surveilShared !== undefined) {
            showData.surveilShared = nowFormData.surveilShared;
          }
          if (nowFormData.mType) {
            showData.mType = nowFormData.mType;
          }
          if (nowFormData.points) {
            showData.points = nowFormData.points;
          }
          //showData=nowFormData;
        }
        if (mType) {
          showData.mType = mType;
          if (tempData) {
            if (mType === "pointToIcon") {
              showData.position = tempData;
            }
          }
        }

        this.$refs.BimVideoTree.surveilEdit(showData);
      }
    },
    // 目录树更新已修改成功的标记。
    updateSimVideoCamera(data) {
      this.$refs.BimVideoTree.treeEditItem(data);
    },
    // 删除节点
    deleteSimVideoCamera(data) {
      let that = this;
      this.$confirm("确定删除该摄像头吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除树节点
          if (data.children == undefined || data.children.length <= 0) {
            //axios请求删除节点代码
            let mrdData = {
              projectId: parseInt(
                window.sessionStorage.getItem("nowProjectId")
              ),
              id: data.id,
            };
            deleteSurveil(mrdData).then((res) => {
              // console.log(JSON.parse(JSON.stringify(res)));
              // console.log(444444444444);
              if (res.data.success && res.data.code === 204) {
                that.open_surveil_box = ""; //清除标记的时候先关闭编辑标记表单，避免标记没了，信息还可以提交。

                that.$GLOBAL.markDrawGraphicLayer.removeGraphic(
                  that.$GLOBAL.markDrawGraphicLayerObj
                );

                that.initTreeData(); //请求后台数据刷新
                //that.$refs.BimVideoTree.treeDeleteItem(data); //本地刷新，演示效果用,但会导致一个问题，就是旧数据里的数据没有更新。

                that.$notify({
                  title: "已成功删除该摄像头。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                that.$alert("删除该摄像头失败了，请再试一次吧~", "删除失败", {
                  confirmButtonText: "确定",
                  type: "error",
                  callback: (action) => {},
                });
              }
            });

            // if (data.localFiles) {
            //   let tempArr = data.localFiles.split(",");

            //   for (let i = 0; i < tempArr.length; i++) {
            //     let fData = {
            //       id: parseInt(tempArr[i]),
            //     };
            //     //逐个删除该摄像头的文件
            //     deleteFile(fData)
            //       .then((res) => {
            //         // console.log(JSON.parse(JSON.stringify(res)));
            //         // alert(fData.id);
            //         // console.log(777);
            //       })
            //       .catch(function(err) {
            //         console.log(err);
            //       });
            //   }
            // }
          } else {
            this.$alert("删除失败，因为该目录不为空目录。", "友情提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
        });
    },
    surveilNodeClick(data) {
      //alert(data.surveilType);
      if (data.uid) {
        let layer = this.$GLOBAL.markDrawGraphicLayer.getGraphicById(data.uid);
        this.$GLOBAL.markDrawGraphicLayerObj = layer;
        // console.log(layer);
        // console.log(layer._points);
        // console.log(layer._positions);
        // return false;
        if (data.surveilType === "polyline" || data.surveilType === "polygon") {
          // 注意这里应该是定位到layer._points，而不是layer._positions。对于polygon和polyline，layer._positions是一个回调函数CallbackProperty，会导致页面卡死。
          this.$GLOBAL.map.flyToPositions(layer._points, {
            minHeight: 100,
            maxHeight: 1500,
            duration: 2,
          });
        } else {
          // layer.flyTo({
          // 	minHeight: 100,
          // 	maxHeight: 5000,
          // 	duration: 2,
          // });
          layer.flyTo({
            minHeight: 100,
            maxHeight: 1500,
            duration: 2,
          });
        }

        // console.log(layer);
        // console.log(111);
        layer.hasEdit = true;
        this.$refs.bimVideoCamera.bindMourseClick(true, data.surveilType);
      }
    },
    initSurveilArray(data) {
      //根据数据库加载出来的项目的标记数据显示到地图上。

      if (!this.$GLOBAL.markDrawGraphicLayer) {
        this.$GLOBAL.markDrawGraphicLayer = new mars3d.layer.GraphicLayer({});
        // if (
        //   this.$refs.bimVideoCamera == undefined ||
        //   this.$refs.bimVideoCamera.title == "编辑"
        // ) {
        //   this.$GLOBAL.markDrawGraphicLayer = new mars3d.layer.GraphicLayer({});
        // } else if (this.$refs.bimVideoCamera.title == "添加") {
        //   console.log("添加的");
        //   this.$GLOBAL.markDrawGraphicLayer = new mars3d.layer.GraphicLayer({
        //     // 暂时不能拖动
        //     hasEdit: true,
        //     isAutoEditing: true, //绘制完成后是否自动激活编辑
        //   });
        // }
        this.$GLOBAL.map.addLayer(this.$GLOBAL.markDrawGraphicLayer);

        let that = this;

        this.$GLOBAL.markDrawGraphicLayer.on(mars3d.EventType.click, function(
          e
        ) {
          var point = mars3d.LngLatPoint.fromCartesian(e.graphic._position);
          point.format(); //经度、纬度、高度
          let currJD = point.lng;
          let currWD = point.lat;
          let currGD = point.alt;
          let cartesianXYZ = currJD + "," + currWD + "," + currGD;
          EventBus.$emit("updateCartesian", {
            cartesianXYZ: cartesianXYZ,
            graphic: e.graphic,
            mType: "pointToIcon",
          });
        });

        // 暂时不能拖动
        this.$GLOBAL.markDrawGraphicLayer.on(
          mars3d.EventType.editMovePoint,
          function(e) {
            //console.log('编辑修改了点', e)
            //let mType = e.graphic.options.type;
            let point2 = mars3d.LngLatPoint.fromCartesian(e.graphic._position);
            point2.format(); //经度、纬度、高度

            let currJD = point2.lng;
            let currWD = point2.lat;
            let currGD = point2.alt;
            let cartesianXYZ = currJD + "," + currWD + "," + currGD;
            //alert(cartesianXYZ)
            EventBus.$emit("updateCartesian", {
              cartesianXYZ: cartesianXYZ,
              graphic: e.graphic,
              mType: "pointToIcon",
            });
          }
        );
      }

      let iconImgUrl, graphicImg, tposition, iconLineColor;
      this.$GLOBAL.markDrawGraphicLayer.clear();
      if (this.$GLOBAL.markDrawGraphicLayer2) {
        this.$GLOBAL.markDrawGraphicLayer2.clear();
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].surveilType === "pointToIcon") {
          // if (!data[i].surveilIconColor) {
          if (!data[i].bimVideoCamera["labelColor"]) {
            data[i].bimVideoCamera[
              "labelColor"
            ] = this.$GLOBAL.default_markIconColor;
          }
          iconLineColor = data[i].bimVideoCamera["labelColor"];
          // iconImgUrl =
          //   "/img/marker/bimVideo/surveil" + iconLineColor.slice(1) + ".png";
          iconImgUrl = require("@/../public/img/marker/bimVideo/surveil" +
            iconLineColor.slice(1).toLowerCase() +
            ".png");
          tposition = data[i].bimVideoCamera.position.split(",");
          graphicImg = new mars3d.graphic.DivGraphic({
            position: tposition,
            style: {
              html: ` <div class="mars3d-camera-content">
						                      <img class="mars3d-camera-img" src="${iconImgUrl}" >
						                    </div>
						                    <div class="mars3d-camera-line" style="border-left-color:${iconLineColor}"></div>
						                    <div class="mars3d-camera-point" style="background-color:${iconLineColor}"></div>
						                  `,
              offsetX: -16,
              distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
                0,
                100000
              ),
            },
          });
          this.$GLOBAL.markDrawGraphicLayer.addGraphic(graphicImg);
          let parentObject = this.treeData.find(
            (item) => item.id == data[i].parentId
          );
          let childObject = parentObject.children.filter(
            (item) => item.id == data[i].id
          );
          childObject[0].uid = graphicImg.id;
          childObject[0].bimVideoCamera.position =
            data[i].bimVideoCamera.position;
          childObject[0].bimVideoCamera.labelColor =
            data[i].bimVideoCamera.labelColor;
          data[i].uid = graphicImg.id;
        }
      }
      this.$GLOBAL.markDrawGraphicLayer.unbindContextMenu(true);
      this.bindLayerContextMenu(this.$GLOBAL.markDrawGraphicLayer);
      return data;
    },
    bindLayerContextMenu(graphicLayer) {
      let that = this;
      graphicLayer.bindContextMenu([
        {
          text: "删除对象",
          iconCls: "fa fa-trash-o",
          show: (event) => {
            const graphic = event.graphic;
            if (!graphic || graphic.isDestroy) {
              return false;
            } else {
              return true;
            }
          },
          callback: function(e) {
            const graphic = e.graphic;
            if (!graphic) {
              return;
            }
            //调用后端接口移除，不应该在这里移除。
            // console.log(e.graphic)
            // console.log(e.graphic.uuid)
            // console.log(121212121212);
            let tempData = that.findSimVideoCameraByUid(e.graphic.uuid);
            if (tempData[0] && tempData[0].id) {
              that.deleteSimVideoCamera(tempData[0]);
            }
            //findSimVideoCameraByUid(uid);
            //graphicLayer.removeGraphic(graphic)
          },
        },
      ]);
    },
    handlePointsToArray(points) {
      let rarr = [];
      if (points) {
        let tarr = points.split("|");
        for (let i = 0; i < tarr.length; i++) {
          let t2arr = tarr[i].split(",");
          t2arr = t2arr.map((item) => {
            return Number(item);
          });
          rarr.push(new mars3d.LngLatPoint(t2arr[0], t2arr[1], t2arr[2]));
          //rarr.push(t2arr);
        }
      }
      return rarr;
    },
    showVideo(url) {
      this.playerOptions.sources.src = url;
      this.videoDialogVisible = true;

      //this.$refs.videoPlayer.player.play() // 播放
    },
    handleClose() {
      this.videoDialogVisible = false;
    },
  },
  watch: {},
  destroyed() {
    if (this.$GLOBAL.markDrawGraphicLayer) {
      this.$GLOBAL.markDrawGraphicLayer.clear();
      this.$GLOBAL.map.removeLayer(this.$GLOBAL.markDrawGraphicLayer, true);
    }
    if (this.$GLOBAL.markDrawGraphicLayer2) {
      this.$GLOBAL.markDrawGraphicLayer2.clear();
      this.$GLOBAL.map.removeLayer(this.$GLOBAL.markDrawGraphicLayer2, true);
    }
    this.$GLOBAL.markDrawGraphicLayer = null;
    this.$GLOBAL.markDrawGraphicLayer2 = null;
    this.$GLOBAL.markDrawGraphicLayerObj = null;

    if (graphicLayer) {
      graphicLayer.clear();
      this.$GLOBAL.map.removeLayer(graphicLayer, true);
      graphicLayer = null;
    }
    // 移除EventBus监听器。
    EventBus.$off("updateCartesian");
  },
};
//console.log(localStorage.getItem(ColorPicker));
